import constants from './constants.js';

const seoMetaManager = (() => {

    const supportedLocales = Object.keys(constants.defaultLocaleOptions);

    const baseUrl = window.location.origin;

    const insertAlternateLinks = (htmlFilename) => {
        const head = document.head;

        // ❌ Remove all existing <link rel="alternate"> tags
        const existingAlternateLinks = head.querySelectorAll('link[rel="alternate"]');
        existingAlternateLinks.forEach(link => link.remove());

        const alternates = [
            { hreflang: 'x-default', locale: '' },
            ...supportedLocales.map(locale => ({ hreflang: locale.toLowerCase(), locale }))
        ];

        const routePath = constants.htmlToPathMap[htmlFilename];

        alternates.forEach(({ hreflang, locale }) => {
            const path = htmlFilename === 'home' ? `/${locale}` : `/${locale}/${routePath}`;
            const link = document.createElement('link');
            link.rel = 'alternate';
            link.hreflang = hreflang;
            link.href = `${baseUrl}${path}`.replace(/\/+/g, '/').replace(':/', '://');
            head.appendChild(link);
        });
    };


    const insertTitleAndMeta = (htmlFilename) => {
        const titleKey = `${htmlFilename}.pageTitle`;
        const descriptionKey = `${htmlFilename}.pageDescription`;
        const keywordsKey = `${htmlFilename}.pageKeywords`;

        const title = getI18n(titleKey) || '';
        const description = getI18n(descriptionKey) || '';
        const keywords = getI18n(keywordsKey) || '';

        document.title = title;

        const metaDescription = document.querySelector('meta[name="description"]') || document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        metaDescription.setAttribute('content', description);
        if (!metaDescription.parentNode) document.head.appendChild(metaDescription);

        const metaKeywords = document.querySelector('meta[name="keywords"]') || document.createElement('meta');
        metaKeywords.setAttribute('name', 'keywords');
        metaKeywords.setAttribute('content', keywords);
        if (!metaKeywords.parentNode) document.head.appendChild(metaKeywords);
    };

    const init = (htmlFilename) => {
        const effectiveFilename = htmlFilename || 'home';
        insertAlternateLinks(effectiveFilename);
        insertTitleAndMeta(effectiveFilename);
    };

    return { init};
})();

export default seoMetaManager;
